import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";

const BOT_REMOVE_ORDER_QUERY_KEY = "bot-remove-order";

export type BotRemoveOrderParams = {
  appPubKey: string;
  userId: string;
  chainId: number;
  orderId: string;
  walletAddress: string;
};

const postBotRemoveOrder = async (api: Api, params: BotRemoveOrderParams) =>
  api.post("orders/delete", { json: params }).json();

const useBotRemoveOrderMutation = () =>
  useMutation<unknown, Error, BotRemoveOrderParams>({
    mutationFn: async (params: BotRemoveOrderParams) =>
      postBotRemoveOrder(api, params),
    mutationKey: [BOT_REMOVE_ORDER_QUERY_KEY],
  });

export {
  useBotRemoveOrderMutation,
  postBotRemoveOrder,
  BOT_REMOVE_ORDER_QUERY_KEY,
};
